import * as React from "react";
import GenericChartComponent from "../GenericChartComponent";
import { getMouseCanvas } from "../GenericComponent";
import { noop } from "../utils";
export class ClickCallback extends React.Component {
    render() {
        const { onMouseDown, onClick, onDoubleClick, onContextMenu, onMouseMove, onPan, onPanEnd, } = this.props;
        return (React.createElement(GenericChartComponent, { onMouseDown: onMouseDown, onClick: onClick, onDoubleClick: onDoubleClick, onContextMenu: onContextMenu, onMouseMove: onMouseMove, onPan: onPan, onPanEnd: onPanEnd, svgDraw: noop, canvasDraw: noop, canvasToDraw: getMouseCanvas, drawOn: ["mousemove", "pan"] }));
    }
}
ClickCallback.defaultProps = {
    disablePan: false,
};
//# sourceMappingURL=ClickCallback.js.map